module.exports = __webpack_public_path__ + "media/images/views/dashboard/gold-4b4e9968f2ad4d50b884c31653e72b00.png";